import React from 'react';
import ReactDOM from 'react-dom';

import nourishmentData from '../../nourishment-data';

class NutritionalInfo extends React.Component {
  render() {
    return (
      <>
        <div className="nutritionalGrid">
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title"></span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-title">per 100g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-title">per 11g stack</span>
            </div>
          </div>

          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Energy (kJ/kcal)</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">949 / 227</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">104 / 25</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Fat</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-text">Of which saturates</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Carbohydrates</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">74.5g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">8.2g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-text">Of which sugars</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Fibre</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Protein</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0g</span>
            </div>
          </div>
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nutrient">
              <span className="nutritionalGrid-title">Salt</span>
            </div>
            <div className="nutritionalGrid-100g">
              <span className="nutritionalGrid-text">0.027g</span>
            </div>
            <div className="nutritionalGrid-11g">
              <span className="nutritionalGrid-text">0.003g</span>
            </div>
          </div>
        </div>

        <br />

        <div className="nutritionalGrid">
          <div className="nutritionalGrid-row">
            <div className="nutritionalGrid-nourishment">
              <span className="nutritionalGrid-title">Nourishment</span>
            </div>
            <div className="nutritionalGrid-amount">
              <span className="nutritionalGrid-title">Amount</span>
            </div>
            <div className="nutrtitionalGrid-NRV">
              <span className="nutritionalGrid-title">NRV</span>
            </div>
          </div>
          {this.props.products.map((product, index) => {
            return (
              <div key={index} className="nutritionalGrid-row">
                <div className="nutritionalGrid-nourishment">
                  <span className="nutritionalGrid-text">{product.title}</span>
                </div>
                <div className="nutritionalGrid-amount">
                  <span className="nutritionalGrid-text">
                    {nourishmentData[product.handle].labelWeight}
                  </span>
                </div>
                <div className="nutritionalGrid-NRV">
                  <span className="nutritionalGrid-text">
                    {nourishmentData[product.handle].NRV}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  }
}

export default NutritionalInfo;
